import { gql } from 'graphql-request';

import type { SEO } from '@/types/seo';

interface FaqsPageContent extends SEO {
  heroImage: string;
}

export const createFaqsPageQuery = () => gql`
  query getFaqsPage {
    FaqsPage {
      heroImage {
        sizes {
          hero {
            url
          }
        }
      }
      seo {
        title
        description
        image {
          url
        }
      }
    }
  }
`;

export const mapToFaqsPageContent = (data: any): FaqsPageContent => {
  return {
    heroImage: data.FaqsPage?.heroImage?.sizes?.hero?.url || '',
    seo: data.FaqsPage.seo,
  };
};
